
// Helper functions
const MONTH_NAMES = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
// Utility function to get current date dynamically
export const getCurrentDate = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const financialYearStartMonth = 3;
    const financialYearStartYear = currentMonth < financialYearStartMonth ? currentYear - 1 : currentYear;
    const financialYearEndYear = financialYearStartYear + 1;
    const date_1 = new Date(`${financialYearStartYear}-${financialYearStartMonth + 1}-01`)
    const date_2 = new Date(`${financialYearEndYear}-${financialYearStartMonth}-31`)
    const financialYear = `${date_1.getDate()}-${date_1.toLocaleString('default', { month: 'short' })}-${date_1.getFullYear()} To ${date_2.getDate()}-${date_2.toLocaleString('default', { month: 'short' })}-${date_2.getFullYear()}`;
    const current_date_redux = `${currentDate.toLocaleString('en-US', { weekday: 'long' })},  ${currentDate.getDate()}-${currentDate.toLocaleString('default', { month: 'short' })}-${currentDate.getFullYear()}`
    const current_date = `${currentDate.getDate()}-${currentDate.toLocaleString('default', { month: 'short' })}-${currentDate.getFullYear()}`
    
    return {
        current_date_redux,
        current_date,
        financialYear,
        start_financial_year: date_1,
        end_financial_year: date_2
    };
};

// Function to check if date needs to be updated
export const shouldUpdateDate = (lastUpdateDate) => {
    if (!lastUpdateDate) return true;
    
    const today = new Date().toDateString();
    const lastUpdate = new Date(lastUpdateDate).toDateString();
    
    return today !== lastUpdate;
};

// Function to get stored last update date
export const getLastUpdateDate = () => {
    return localStorage.getItem('lastDateUpdate');
};

// Function to set last update date
export const setLastUpdateDate = () => {
    localStorage.setItem('lastDateUpdate', new Date().toISOString());
}; 

// Function to validate date input according to the format like DD.MM.YYYY, DD/MM/YY, DD MMM YY, or DD[MMM]YYYY
export const validateDateInput = (input) => {
    let match = input.match(/^(\d+)([^\d])(\d+)([^\d])?(\d*)$/);
    
    if (match) {
      const [, day, , month, , year] = match;
      const parsedDay = parseInt(day, 10);
      const parsedMonth = parseInt(month, 10);
      
      if (parsedMonth < 1 || parsedMonth > 12) return null;
      
      const daysInMonth = new Date(2000, parsedMonth, 0).getDate();
      if (parsedDay < 1 || parsedDay > daysInMonth) return null;

      if(year.length === 3 || year.length > 4)return null;
      return { day: parsedDay, month: parsedMonth, year };
    }
    
    // Second try: Month name format (DD[separator]MMM[separator]YYYY)
    // Support patterns like: 1,j,20, 1.ja.24, 1[mar]2020, 12/Apr/2024, 01-Aug-25, 2's'2025, 3 dec 24, 31|December|2025, 4{JUL}20, 5@sep@2024
    
    // Enhanced month names array with variations
    const MONTH_VARIANTS = {
      // Abbreviated months (3 letters)
      'jan': 1, 'feb': 2, 'mar': 3, 'apr': 4, 'may': 5, 'jun': 6,
      'jul': 7, 'aug': 8, 'sep': 9, 'oct': 10, 'nov': 11, 'dec': 12,
      // Single letter abbreviations
      'j': 1, 'f': 2, 'm': 3, 'a': 4, 'y': 5, 'u': 6,
      'l': 7, 'g': 8, 's': 9, 'o': 10, 'n': 11, 'd': 12,
      // Full month names
      'january': 1, 'february': 2, 'march': 3, 'april': 4, 'may': 5, 'june': 6,
      'july': 7, 'august': 8, 'september': 9, 'october': 10, 'november': 11, 'december': 12
    };
    
    // Pattern: DD[separator]MMM[separator]YYYY
    const monthNamePattern = /^(\d+)([^\d\w])([a-zA-Z]+)([^\d\w])(\d+)$/;
    match = input.match(monthNamePattern);
    
    if (match) {
      const [, day, , monthStr, , year] = match;
      const parsedDay = parseInt(day, 10);
      const parsedYear = parseInt(year, 10);
      const monthKey = monthStr.toLowerCase();
      
      if (!MONTH_VARIANTS[monthKey]) return null;
      
      const parsedMonth = MONTH_VARIANTS[monthKey];
      
      const daysInMonth = new Date(2000, parsedMonth, 0).getDate();
      if (parsedDay < 1 || parsedDay > daysInMonth) return null;
      if(year.length === 3 || year.length > 4)return null;
      return { day: parsedDay, month: parsedMonth, year: parsedYear };
    }
    
    // Third try: DD[separator]MMM[separator]YY (any year length)
    const monthNamePatternShort = /^(\d+)([^\d\w])([a-zA-Z]+)([^\d\w])(\d+)$/;
    match = input.match(monthNamePatternShort);
    
    if (match) {
      const [, day, , monthStr, , year] = match;
      const parsedDay = parseInt(day, 10);
      const parsedYear = parseInt(year, 10);
      const monthKey = monthStr.toLowerCase();
      
      if (!MONTH_VARIANTS[monthKey]) return null;
      
      const parsedMonth = MONTH_VARIANTS[monthKey];
      
      const daysInMonth = new Date(2000, parsedMonth, 0).getDate();
      if (parsedDay < 1 || parsedDay > daysInMonth) return null;
      if(year.length === 3 || year.length > 4)return null;
      return { day: parsedDay, month: parsedMonth, year: parsedYear };
    }
    
    // Fourth try: DD MMM YY (space separated, any year length)
    const spacePattern = /^(\d+)\s+([a-zA-Z]+)\s+(\d+)$/;
    match = input.match(spacePattern);
    
    if (match) {
      const [, day, monthStr, year] = match;
      const parsedDay = parseInt(day, 10);
      const parsedYear = parseInt(year, 10);
      const monthKey = monthStr.toLowerCase();
      
      if (!MONTH_VARIANTS[monthKey]) return null;
      
      const parsedMonth = MONTH_VARIANTS[monthKey];
      
      const daysInMonth = new Date(2000, parsedMonth, 0).getDate();
      if (parsedDay < 1 || parsedDay > daysInMonth) return null;
      if(year.length === 3 || year.length > 4)return null;
      return { day: parsedDay, month: parsedMonth, year: parsedYear };
    }
    
    return null;
  };

  // Function to format date string to the format like DD-MMM-YYYY
  export const formatDateString = (day, month, year ,type) => {
    const monthAbbreviation = MONTH_NAMES[month - 1];
    return {
      display: `${day}-${monthAbbreviation}-${year}`,
      send: `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    };
  };


  export const getFinancialYear = (company_session) => {
    const startYear = new Date(company_session?.start_financial_year).getFullYear();
    const endYear = new Date(company_session?.end_financial_year).getFullYear();
    return { startYear, endYear };
  };

  export const parseYear = (yearInput, currentYear) => {
    if (yearInput.length === 2) {
      const currentCentury = Math.floor(currentYear / 100) * 100;
      return parseInt(yearInput, 10) + currentCentury;
    } else if (yearInput.length === 4) {
      return parseInt(yearInput, 10);
    }
    return null;
  };